/**
 * @flow
 * @format
 */
/* eslint-disable no-unused-vars */

import React from 'react';
import { Row, Col, Card } from 'reactstrap';
import cc from 'classcat';
import _ from 'lodash';

import { branch } from '~/utils';
import debug from '~/utils/macros/debug.macro';

import LazyImage from '../LazyImage';
import FieldWrapper from '../FieldWrapper';
import SubStepWrapper from '../SubStepWrapper';
import GraphRowPaderator from '../GraphRowPaderator';

import classes from './StepWrapper.scss';

type PropsType = {
  data: StepData,
};

const INPUT_WIDTH = +process.env.REACT_APP_LEFT_PANE_SIZE;
const OFFSET = +process.env.REACT_APP_PANEL_OFFSET;

export class StepWrapper extends React.PureComponent<PropsType, *> {
  static defaultProps = {
    data: {},
  };

  props: PropsType; // eslint-disable-line react/sort-comp

  render() {
    const { data } = this.props;
    const span = _.get(data, 'image-span', []);
    const mergeSteps =
      span.length > 0 ? _.pick(data.steps, span.split(', ')) : [];
    const mergedSection = _.reduce(
      mergeSteps,
      (a, s: StepSectionData) =>
        [].concat(
          a,
          _.map(s.images, img => <LazyImage key={img.file} {...img} />),
        ),
      [],
    );

    const steps = data.steps || [];
    const rightPane: Array<*> = _.reduce(
      steps,
      (a: Array<*>, step: StepSectionData, i: any) => {
        if (span.length > 0) {
          // merges can only be in a row - include the merged section here
          if (span[0] === i) {
            return [].concat(
              a,
              <Row key={span}>
                <Col className={classes.imageCol}>
                  <Card body className={classes.imageCard}>
                    {mergedSection}
                  </Card>
                </Col>
              </Row>,
            );
          }
          // Ignore other sections since they are already merged
          if (span.includes(i)) return a;
        }

        const graphs =
          step.graphs &&
          _.map(step.graphs, (graph, key: string) => (
            <Row key={key} id={key}>
              <Col className={classes.imageCol}>
                <FieldWrapper
                  id={key}
                  data={{ type: 'graph', name: graph.name }}
                  style={{ border: '0 !important' }}
                  onChangeHandler={() => {}}
                  onRevertHandler={() => {}}
                />
              </Col>
            </Row>
          ));

        const images = step.images &&
          step.images.length > 0 && (
            <Row key={`${i}-images`} id="step-images">
              <Col className={classes.imageCol}>
                <Card body className={classes.imageCard}>
                  {_.map(step.images, img => (
                    <Row key={img.file}>
                      <Col>
                        <LazyImage {...img} />
                      </Col>
                    </Row>
                  ))}
                </Card>
              </Col>
            </Row>
          );

        const padding = graphs && (
          <GraphRowPaderator
            key={`${step.name}-padding`}
            target="step-images"
            graphTarget="inductor-performance-summary"
          />
        );

        return [].concat(a, images, padding, graphs);
      },
      [],
    );

    const width = INPUT_WIDTH - OFFSET * 2;

    return (
      <Row className={classes.wrapper}>
        <Col lg={{ size: width, offset: OFFSET }} md={12} sm={12}>
          {_.map(data.steps, (val: StepSectionData, key: string) => (
            <SubStepWrapper key={key} data={val} />
          ))}
        </Col>
        {branch(
          rightPane.length > 0,
          <Col
            lg={{
              size: 12 - width,
              offset: OFFSET,
            }}
            md={12}
            sm={12}
          >
            {rightPane}
          </Col>,
        )}
      </Row>
    );
  }
}

/*
        <Col sm={12 - INPUT_WIDTH} className={classes.imageCol}>
          <Card body className={classes.imageCard}>
            {graphPane}
          </Card>
        </Col>
        */

export default StepWrapper;



// WEBPACK FOOTER //
// ./src/components/StepWrapper/StepWrapper.js